<template>
  <div class="p-[12px_16px]">
    <div
      v-if="hasPagePermission(PageKey.TUTORIAL)"
      class="bg-back-3 p-[9px_12px] rounded-[8px] flex-y-center gap-[6px]"
    >
      <iconpark-icon name="book" size="16" />
      <span>
        {{ $t('kuai-lai-cha-kan-you-yan-ke-tang') }}
        <a @click.prevent="go">
          {{ $t('gao-xiao-sheng-cheng-shi-pin-ji-qiao') }}
        </a>
        {{ $t('jiao-ni-ru-he-he-li-shi-yong') }}
      </span>
    </div>
    <a-tabs destroyInactiveTabPane class="consume-tabs">
      <a-tab-pane
        v-for="x in panes"
        :key="x.key"
        :tab="x.tab"
        class="p-[4px_16px_8px]"
      >
        <video
          :src="x.src"
          autoplay
          loop
          muted
          class="block w-full h-[555px] bg-back-3 rounded-[8px]"
        />
        <!-- <div class="mt-[12px] flex-y-center gap-[6px] text-12">
          <iconpark-icon name="info-fill" />
          <span>{{ x.tip }}</span>
        </div> -->
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script lang="ts" setup>
import { PageKey } from '~/constants/page'

const { $t } = useNuxtApp()

const props = defineProps<{ cancel: () => void }>()

const { hasPagePermission } = usePageAndActionPermissionData()

const panes = [
  {
    key: '1',
    tab: $t('ai-jiao-ben-sheng-cheng'),
    src: getFeUrl('/youyan-platform/video/AI%E8%84%9A%E6%9C%AC.mp4'),
  },
  {
    key: '2',
    tab: $t('yu-lan-shi-pin'),
    src: getFeUrl('/youyan-platform/video/%E9%A2%84%E8%A7%88.mp4'),
  },
  {
    key: '3',
    tab: $t('ai-sheng-cheng'),
    src: getFeUrl(
      '/youyan-platform/video/%E4%B8%80%E9%94%AE%E7%94%9F%E6%88%90.mp4'
    ),
  },
  {
    key: '4',
    tab: $t('xuan-ran-shi-pin'),
    src: getFeUrl('/youyan-platform/video/%E6%B8%B2%E6%9F%93.mp4'),
  },
  {
    key: '5',
    tab: $t('shi-pin-dao-chu'),
    src: getFeUrl(
      '/youyan-platform/video/%E5%AF%BC%E5%87%BA%E8%A7%86%E9%A2%91.mp4'
    ),
  },
]

const router = useRouter()

const go = () => {
  props.cancel()
  router.push({
    name: PageKey.TUTORIAL_INFO,
    params: { id: '9' },
  })
}
</script>

<style lang="scss" scoped>
.consume-tabs {
  :deep(.ant-tabs-nav) {
    padding: 0 16px;
  }
  :deep(.ant-tabs-tab) {
    padding-left: 11px;
    padding-right: 11px;
  }
}
</style>
